import themeService from "ThemeService";
import util from "util/Util";
import { ensurePxUnit, parseValue } from './mobileUtils';
import styled, { css } from 'styled-components';


export const getFontStyleProps = (model) => {
    return {
        fontFamily: parseValue(model.get('fontFamily'), 0),
        fontSize: ensurePxUnit(parseValue(model.get('fontSize'), 1)),
        textAlign: model.get('align'),
        fontWeight: parseValue(model.get('textWeight')?.replace(' !important', ''), 2),
        fontStyle: parseValue(model.get('textStyle')?.replace(' !important', ''), 3),
        color: parseValue(model.get('styleColorText'))
    };
};

export const getBorderStyleProps = (model) => {
    return {
        backgroundColor: parseValue(model.get('backgroundColor') || '~inputBgColor'),
        borderColor: parseValue(model.get('borderColor') || '~inputBorderColor'),
        borderStyle: parseValue(model.get('borderStyle'), 1),
        borderRadius: ensurePxUnit(parseValue(model.get('cornerRadius'), 2)),
        borderSize: ensurePxUnit(parseValue(model.get('borderSize'), 0)),
        backgroundColor: util.isTrue(model.get('transparentBackground'))
            ? 'transparent'
            : parseValue(model.get('backgroundColor'))
    };
};

export const getTextStyleProps = (model) => {
    return getFontStyleProps(model);
};

export const getButtonStyleProps = (model) => {
    return {
        ...getFontStyleProps(model),
        ...getBorderStyleProps(model),
        advancedBgGradientColor: parseValue(model.get('advancedBgGradientColor'))
 
    };
};

export const getInputStyleProps = (model) => {
    return {
        ...getFontStyleProps(model),
        ...getBorderStyleProps(model)
    };
};

export const getSelectionControlStyleProps = (model) => {
    return {
        ...getFontStyleProps(model), 
        ...getBorderStyleProps(model)
    };
};

export const getCalendarStyleProps = (model) => {
    return {
        ...getFontStyleProps(model),
        ...getBorderStyleProps(model)
    };
};

export const getGroupStyleProps = (model) => {
    
    return {
        container: getBorderStyleProps(model),
        header: {
            backgroundColor: parseValue(model.get('titleBackgroundColor') || '~groupTitleBg'),
            color: parseValue(model.get('titleColor') || '~groupTextColor'),
            fontFamily: parseValue(model.get('titleFontFamily') || '~groupFont', 0),
            fontSize: ensurePxUnit(parseValue(model.get('titleFontSize') || '~groupFont', 1)),
            fontWeight: parseValue(model.get('titleTextWeight') || '~groupFont', 2),
            textAlign: model.get('titleAlign'),
            height: ensurePxUnit(model.get('titleHeight')),
        },
        children: getSelectionControlStyleProps(model),
    };
};

export const getSeparatorsStyleProps = (model) => {
    const styles = {
        backgroundColor: parseValue(model.get('lineColor'))
    }

    return styles;
};

export const getSliderStyleProps = (model) => {
    return {
        ...getFontStyleProps(model), 
        sliderColor: parseValue(model.get('sliderColor')),
        tickColor: parseValue(model.get('tickColor')),
        scaleColor: parseValue(model.get('scaleColor')),
    };
};

export const getWebSignatureButtonStyleProps = (model) => {
    return {
        // Map font properties
        fontFamily: parseValue(model.get('buttonFontFamily'), 0),
        fontSize: ensurePxUnit(parseValue(model.get('buttonFontSize'), 1)),
        fontWeight: parseValue(model.get('buttonTextWeight')?.replace(' !important', ''), 2),
        fontStyle: parseValue(model.get('buttonTextStyle'), 3),
        color: parseValue(model.get('buttonTextColor')),
        padBackgroundColor: model.get('imageBackgroundColor'),

        // Map border properties
        borderColor: '#ABABAB',
        borderStyle: 'solid',
        borderRadius: '2px',
        borderSize: '1px',

        // Map background properties
        backgroundColor: parseValue(model.get('buttonBackgroundColor')),
        advancedBgGradientColor: parseValue(model.get('buttonBackgroundGradientColor'))
    };
};

export const getTableStyleProps = (model) => {
    return {
        ...getBorderStyleProps(model),

        // Header styles
        headerBackgroundColor: parseValue(model.get('headerBgColor') || '~tableHeaderBgColor'),
        headerBgColorGradient: parseValue(model.get('headerBgColorGradient') || '~tableHeaderBgGradientColor'), 
        headerColor: parseValue(model.get('styleHeaderColorText') || '~tableHeaderTextColor'),
        headerFontFamily: parseValue(model.get('headerFontFamily') || '~tableHeaderFont', 0),
        headerFontSize: ensurePxUnit(parseValue(model.get('headerFontSize') || '~tableHeaderFont', 1)),
        headerTextWeight: parseValue(model.get('headerTextWeight') || '~tableHeaderFont', 2),
        headerTextStyle: parseValue(model.get('headerTextStyle') || '~tableHeaderFont', 3), 

        // Row styles
        normalRowBgColor: parseValue(model.get('normalRowBgColor') || '~tableRowColor1'),
        alternateRowBgColor: parseValue(model.get('alternateRowBgColor') || '~tableRowColor2'),
    };
};

export const getRankingStyleProps = (model) => {
    return getInputStyleProps(model);
};

export const getImageStyleProps = (model) => {
    const styles = {
        backgroundColor: parseValue(model.get('backgroundColor')),
        borderColor: parseValue(model.get('borderColor')),
    }

    return styles;
};

export const getProgressBarStyleProps = (model) => {
    return {
        ...getTextStyleProps(model),
        barColor: parseValue(model.get('barColor')),
        backgroundColor: parseValue(model.get('backgroundColor')),
        borderColor: parseValue(model.get('borderColor')),
        borderStyle: "solid"
    };
};

export const getCaptchaStyleProps = (model) => {
    const styles = {
        backgroundColor: parseValue(model.get('backgroundColor')),
        borderColor: parseValue(model.get('borderColor')),
        color: parseValue(model.get('styleColorText')),
    }

    return styles;
};

export const getFileAttachmentStyleProps = (model) => {
    const buttonFontStyles = {
        buttonFontFamily: parseValue(model.get('buttonFontFamily'), 0), 
        buttonFontSize: ensurePxUnit(parseValue(model.get('buttonFontSize'), 1)),
        buttonTextWeight: parseValue(model.get('buttonTextWeight'), 2), 
        buttonTextStyle: parseValue(model.get('buttonTextStyle'), 3),
        buttonTextColor: themeService.resolve(model.get('buttonTextColor'))
    };

     const labelFontStyles = {
        fontFamily: parseValue(model.get('fontFamily'), 0),
        fontSize: ensurePxUnit(parseValue(model.get('fontSize'), 1)),
        fontWeight: parseValue(model.get('textWeight'), 2), 
        fontStyle: parseValue(model.get('textStyle'), 3),
        color: parseValue(model.get('styleColorText'))
    };

    const borderStyles = getBorderStyleProps(model);
    borderStyles.backgroundColor = themeService.resolve(model.get('buttonBackgroundColor'));
    borderStyles.advancedBgGradientColor = themeService.resolve(model.get('buttonBackgroundGradientColor'));

    return { ...buttonFontStyles, ...labelFontStyles, ...borderStyles };
};


export const getSectionStyleProps = (model) => {

    return {
        hasTitle: util.isTrue(model.get('hasTitle')),
        titleText: model.get('titleText'),
        titleAlign: model.get('titleAlign'),
        titleHeight: model.get('titleHeight'),
        titleColor: model.get('titleColor'),
        titleFontFamily: model.get('titleFontFamily'),
        titleFontSize: ensurePxUnit(model.get('titleFontSize')),
        titleTextWeight: model.get('titleTextWeight'),
        titleTextStyle: model.get('titleTextStyle'),
        titleBackgroundColor: model.get('titleBackgroundColor'),
        borderColor: model.get('borderColor'),
        borderSize: model.get('borderSize'),
        borderStyle: model.get('borderStyle'),
        cornerRadius: model.get('cornerRadius'),
        backgroundColor: model.get('backgroundColor'),
    };
};


/* ---------- Objects Preview Styled Components -------------------*/

export const TextWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: ${({ styleProps }) => styleProps?.textAlign || 'left'};
  width: 100%;
  height: 100%;
  justify-content: ${({ styleProps }) => styleProps?.textAlign || 'left'};
  white-space: nowrap;
  text-overflow: ellipsis;
  
  ${FontStyles}

  & > div {
    width: 100%;
    height: 100%;
  }
`;

export const ButtonWrapper = styled.button`
    ${SizeStyles}
    ${FontStyles}
    ${BorderStyles}
    ${HoverStyles}
`;


/* ---------- Base Styling -------------------*/
export const SizeStyles = css`
  width: 100%;
  box-sizing: border-box;
  padding: ${({ renderMode }) => (renderMode === 'mobile' ? '4px 8px' : '0')};
  height: ${({ height }) => height};
`;

export const FontStyles = css`
  font-family: ${({ styleProps }) => styleProps?.fontFamily};
  font-size: ${({ styleProps }) => ensurePxUnit(styleProps?.fontSize)};
  font-weight: ${({ styleProps }) => styleProps?.fontWeight};
  font-style: ${({ styleProps }) => styleProps?.fontStyle};
  color: ${({ styleProps }) => styleProps?.color};
`;

export const BorderStyles = css`
  border-radius: ${({ styleProps }) => ensurePxUnit(styleProps?.borderRadius)};
  border-style: ${({ styleProps }) => styleProps?.borderStyle};
  border-color: ${({ styleProps }) => styleProps?.borderColor};
  border-width: ${({ styleProps }) => ensurePxUnit(styleProps?.borderSize) || '1px'};
  background-color: ${({ styleProps }) => styleProps?.backgroundColor};
`;

const HoverStyles = css`
  &:hover {
    color: ${({ styleProps }) => styleProps?.hover?.color};
    background-color: ${({ styleProps }) => styleProps?.hover?.backgroundColor};
  }
`;
